import { client } from "../../../infrastructure/graphql/client";
import {
  GET_ALERT_ANALYSIS,
  ANALYZE_ALERTS_FOR_VM,
  ANALYZE_ALL_VMS_ALERTS,
} from "../../../infrastructure/graphql/aiQueries/alertAnalysisQueries";

export class AlertAnalysisService {
  async getAlertAnalysis(vmId) {
    try {
      const result = await client.query({
        query: GET_ALERT_ANALYSIS,
        variables: { vmId: parseInt(vmId) },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getAlertAnalysis;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get alert analysis error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeAlertsForVm(vmId) {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_ALERTS_FOR_VM,
        variables: { vmId },
      });

      const response = result.data?.analyzeAlertsForVm;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze alerts for VM error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async analyzeAllVmsAlerts() {
    try {
      const result = await client.mutate({
        mutation: ANALYZE_ALL_VMS_ALERTS,
      });

      const response = result.data?.analyzeAllVmsAlerts;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Analyze all VMs alerts error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }
}
